import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
//icon
import {IoClose} from 'react-icons/io5'
import img2 from '../img/3.jpg'
import Qty from '../components/Qty'
import { CartContext } from '../context/CartContext';
const CartItem = () => {
  const {removeFromCart,clear,item} =useContext(CartContext)
  return (<div className=' flex gap-x-8'>
    <a 
    className='w-[70px] h-[70px]'>
    <img src={img2} alt=''></img>
    </a>
    <div className='flex-1'>
      {/* yy */}
      <div className='flex gap-x-4 mb-3'>
        <a >Hungry Duck Shooting</a>
          <div onClick={clear} className=' cursor-pointer text-[24px] hover:text-accent 
            transition-all'>
            <IoClose/>
          </div>
        </div>
        <div className=' items-center flex gap-x-12'>
          {/* lsslsl */}
        <div className='flex gap-x-4 mb-2'>
          {/* <Qty/> */}
          </div>
          <div className='text-accent text-xl'>
            $ 25.99 * {item}=$ {25.99 * item}
          </div>
      </div>
      <div>
          <span className='text-accent '>
          $ 25.99 per price
          </span>
          </div>
    </div>
        </div>
  );
};

export default CartItem;
